import {z} from '@hono/zod-openapi';

const priceSchema = z.number().nullable();

const priceStatsSchema = z.object({
  min: priceSchema,
  max: priceSchema,
  avg: priceSchema,
  percentiles: z.array(z.object({percent: z.number(), price: priceSchema})),
});

const groupSchema = z.object({count: z.number(), price: priceStatsSchema});

/**
 * Alpha's `POST /all_cars/aggregations` answer. The use case parses Alpha's body against it, so
 * an answer that does not match is a 500 and keys Alpha adds later are stripped. Prices are
 * `price_with_vat` in the report currency and null for an empty group; `prices_at_rank` is null
 * past the advertised count; `cheaper_than_query_price` counts strictly cheaper advertised cars
 * and is null without a query price. `sold_30d` is a subset of `sold_90d`, both anchored at the
 * report date.
 */
export const priceReportAggregationsResponseSchema = z
  .object({
    available: groupSchema.extend({
      prices_at_rank: z.array(z.object({rank: z.number(), price: priceSchema})),
      cheaper_than_query_price: z.number().nullable(),
    }),
    sold_30d: groupSchema,
    sold_90d: groupSchema,
  })
  .openapi('PriceReportAggregationsResponse');

export type PriceReportAggregationsResponse = z.infer<typeof priceReportAggregationsResponseSchema>;
